import React from "react";
import styled from "styled-components";
import { InnerLayout } from "../styles/Layouts";
import Title from "./Title";
import ServiceCard from "./ServiceCard";
import design from "../images/design.svg";
import intelligence from "../images/intelligence.svg";
//import gamedev from "../images/game-dev.svg";

function ServicesSection() {
  return (
    <InnerLayout>
      <ServicesSectionStyled>
        <Title title={"Services"} span={"services"} />
        <div className="services">
          <ServiceCard
            image={design}
            title={"Senior QA/Test Automation Engineer"}
            paragraph={
              "With almost 12 years experience as Senior QA/Test Automation Engineer, I have worked with various clients to design and develop Test Automation Frameworks using Java, Selenium WebDriver, Cucumber BDD, TestNG. I also have extensive knowledge in Rest API Testing and Testing of Microservices - Kafka and MQ integrations, all in AWS Environment."
            }
          />
          <div className="mid-card">
            <ServiceCard
              image={intelligence}
              title={"Full Stack Web Developer"}
              paragraph={
                "Self Taught Web Developer with approx 2 years experience creating hobby projects in HTML, CSS, Javascript and React. I completed the Zero To Mastery for Complete Web Developer course in year 2020 from Udemy and several other courses related to Javascript and React from Udemy and Youtube. I have created a number of websites in hands-on tutorial mode using React, Javascript, HTML and CSS knowledge I have acquired so far."
              }
            />
          </div>
          {/* <ServiceCard
            image={gamedev}
            title={"Game Development"}
            paragraph={
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem tenetur ratione quod."
            }
          /> */}
        </div>
      </ServicesSectionStyled>
    </InnerLayout>
  );
}

const ServicesSectionStyled = styled.section`
  .services {
    margin-top: 5rem;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1.5rem;
    @media screen and (max-width: 1000px) {
      flex-direction: column;
    }
    @media screen and (max-width: 950px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media screen and (max-width: 650px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }
`;

export default ServicesSection;
